export default function t() {
  return {
    validate: function validate(t) {
      return {
        valid: true
      };
    }
  };
}